QuickRepliesNameEditionController.$inject = ['$scope','$mdDialog', 'name'];
export function QuickRepliesNameEditionController($scope, $mdDialog, name) {
  $scope.save = save;
  $scope.cancel = cancel;
  $scope.name = name;

  function save(name) {
    $mdDialog.hide(name);
  }

  function cancel() {
    $mdDialog.cancel();
  }
}
